<template>
  <div class="formation-container">
    
    <PlayerInfoBar ref="playerBar" />
    <div class="pitch" :style="{'background-image': 'url(' + imageUrl + ')'}">

      <!-- LEFT TEAM -->
      <div class="left">
        <div
          v-for="(count, rowIndex) in localTeam.formation"
          :key="'local-row-' + rowIndex"
          class="formation-row"
        >
          <div
            v-for="(player) in getPlayersForRow(localTeam.players, localTeam.formation, rowIndex)"
            :key="'local-player-' + player.id"
            class="player local"
            @click="openPlayerInfo(player.id,matchData.matchid,localFormation)"
          >
            <div class="player-img-wrapper">
              <span v-if="player.jerseynumber" class="jersey-number">{{ player.jerseynumber }}</span>
              <img
                :src="player.image"
                @error="handleImageError"
                alt="player"
                class="player-img"
                :style="getPlayerBorderStyle(true)"
              />
              <span v-if="player.yellowcard" class="badge yellow-card"></span>
              <span v-if="player.redcard" class="badge red-card"></span>
              <span v-if="player.substitute" class="badge substitute-badge">&#8646;</span>
              <span v-if="player.goals >= 1" class="goal-badge">⚽<span v-if="player.goals > 1" class="goal-count">{{ player.goals }}</span></span>
              <span v-if="player.owngoals >= 1" class="owngoal-badge" title="Own goal">⚽<span v-if="player.owngoals > 1" class="goal-count">{{ player.owngoals }}</span></span>
            </div>
            <span class="player-name">{{ player.name }}</span>
          </div>
        </div>
      </div>

      <!-- RIGHT TEAM -->
      <div class="right">
        <div
          v-for="(count, rowIndex) in visitorTeam.formation"
          :key="'visitor-row-' + rowIndex"
          class="formation-row"
        >
          <div
            v-for="(player) in getPlayersForRow(visitorTeam.players, visitorTeam.formation, rowIndex)"
            :key="'visitor-player-' + player.id"
            class="player visitor"
            @click="openPlayerInfo(player.id,matchData.matchid,visitorFormation)"
          >
            <div class="player-img-wrapper">
              <span v-if="player.jerseynumber" class="jersey-number">{{ player.jerseynumber }}</span>
              <img
                :src="player.image"
                @error="handleImageError"
                alt="player"
                class="player-img"
                :style="getPlayerBorderStyle(false)"
              />
              <span v-if="player.yellowcard" class="badge yellow-card"></span>
              <span v-if="player.redcard" class="badge red-card"></span>
              <span v-if="player.substitute" class="badge substitute-badge">&#8646;</span>
              <span v-if="player.goals >= 1" class="goal-badge">⚽<span v-if="player.goals > 1" class="goal-count">{{ player.goals }}</span></span>
              <span v-if="player.owngoals >= 1" class="owngoal-badge" title="Own goal">⚽<span v-if="player.owngoals > 1" class="goal-count">{{ player.owngoals }}</span></span>
            </div>
            <span class="player-name">{{ player.name }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PlayerInfoBar from './FootballPlayer.vue';

export default {
  name: "FootballFormationCompact",
  props: {
    localTeam: { type: Object, required: true },
    visitorTeam: { type: Object, required: true },
    matchData: { type: Object, required: true },
    localFormation: { type: String, required: true },
    visitorFormation: { type: String, required: true },
    teamColor: { type: Object, required: true },
    selectsportid: { type: String, required: true }
  },
  components: { PlayerInfoBar },
  data() {
    return {
      imageUrl: require("@/assets/football.png"),
       
    };
  },
  
  methods: {
    getPlayerBorderStyle(isHome) {
    const color = isHome
      ? this.teamColor.home
      : this.teamColor.away;

    return {
      borderColor: color,
      boxShadow: `0 0 10px ${this.hexToRgba(color, 0.7)}`
    };
  },

  hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  },
    getPlayersForRow(players, formation, rowIndex) {
      const start = formation
        .slice(0, rowIndex)
        .reduce((a, b) => a + parseInt(b), 0);
      const end = start + parseInt(formation[rowIndex]);
      return players.slice(start, end);
    },

    handleImageError(event) {
      event.target.style.display = "none";
      const number = event.target.parentElement.querySelector(".player-number");
      if (number) number.style.display = "block";
    },
      openPlayerInfo(playerid,matchid,formation) 
      {
         if (!playerid || playerid === 0) {
          return; // Stop execution
         }
       var sportsid = this.selectsportid;    
      
       this.$store.dispatch('fetchFootballPlayerData', { playerid, matchid, sportsid }).then(player => {
         const playerData = player.data;
         playerData.formation = formation;
          this.$refs.playerBar.openPlayer(playerData);
       });
      //this.$refs.playerBar.openPlayer(player);
    }
  }
};
</script>
<style scoped>
.formation-container {
  max-width: 800px;
  margin: 10px auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.pitch {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
  border-radius: 8px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  padding: 20px;
}

/* Left and right teams */
.left,
.right {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 48%;
  height: 100%;
  position: relative;
}
.right {
  flex-direction: row-reverse;
} 
/* mirror right team horizontally so both face the middle */
 
/* each row represents one line of players (DEF, MID, ATT) */
.left .formation-row {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  position: relative;
  flex-direction: column-reverse;
}
.right .formation-row {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  position: relative;
  flex-direction: column;
}

/* reverse mirroring for player content inside the right side */
 
/* Player styling */
.player {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.player:hover {
  transform: scale(1.1);
  z-index: 10;
}

/* Player image wrapper */
.player-img-wrapper {
  position: relative;
  display: block;
  line-height: 0;
  width: fit-content;
}

/* Player image */
.player-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  display: block;
}

/* Card badges — top-left like Sofascore */
.badge {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 11px;
  height: 15px;
  border-radius: 2px;
  border: 1.5px solid #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

.yellow-card {
  background-color: #f5c518;
}

.red-card {
  background-color: #e5173f;
}

/* Substitute badge — middle-left, Sofascore style */
.substitute-badge {
  position: absolute;
  top: 50%;
  left: -5px;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 1px 4px rgba(0,0,0,0.35);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 0;
  gap: 0px;
}

.substitute-badge::before {
  content: '↑';
  font-size: 9px;
  font-weight: 700;
  color: #28a745;
  line-height: 1;
}

.substitute-badge::after {
  content: '↓';
  font-size: 9px;
  font-weight: 700;
  color: #e5173f;
  line-height: 1;
}

/* Goal badge — top-right like Sofascore */
.goal-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  border: 1.5px solid #ddd;
  box-shadow: 0 1px 3px rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
}

.goal-count {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #e5173f;
  color: #fff;
  font-size: 7px;
  font-weight: 700;
  border-radius: 50%;
  width: 9px;
  height: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

/* Own-goal badge — bottom-right, red circle like Sofascore so it reads
   distinctly from a normal goal (and never overlaps one at top-right) */
.owngoal-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e5173f;
  border: 1.5px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
}

/* Jersey number badge — top-center on player image */
.jersey-number {
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  /*z-index: 5;*/
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  line-height: 1;
  border: 1.5px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

/* Player number */
.player-number {
  display: none;
  font-size: 12px;
  font-weight: bold;
  color: #000;
  background: #fff;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Player name */
.player-name {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  margin-top: 4px;
   cursor: pointer;   
}

/* Team color styles 
.local .player-img {
  border-color: #ff4757;
  box-shadow: 0 0 10px rgba(255, 71, 87, 0.7);
}

.visitor .player-img {
  border-color: #3742ff;
  box-shadow: 0 0 10px rgba(55, 66, 255, 0.7);
}
  */
.lineup {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 40px;
}


.player-name:hover {
  text-decoration: underline;
}

/* Animations */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Responsive */
/* MOBILE: portrait pitch + facing teams */
@media (max-width: 480px) {

  .formation-container {
    margin: 6px auto;
    padding: 0;
    /*max-width: 360px;*/ /* match phone width (adjust if needed) */
  }

  .pitch {
    /* KEEP inline background-image (from :style) for desktop.
       For mobile override with a portrait image */
    background-image: url('~@/assets/football-vertical.png') !important;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    width: 100%;
    height: 720px;       /* adjust to taste */
    display: flex;
    flex-direction: column; /* teams stacked vertically */
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-radius: 8px;
    overflow: hidden;
  }

  /* both teams take roughly half the pitch vertically */
  .left,
  .right {
    width: 100%;
    height: 48%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    transform: none; /* ensure no leftover transforms */
  }

  /* visitor (top) should face downward — flip container 180deg */
  .right {
    transform: rotate(180deg);
  }

  /* Reflip player content inside the flipped right team so faces/names are readable */
  .right .player {
    transform: rotate(180deg);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* bottom team should face up — column-reverse keeps ordering natural */
  .left {
    flex-direction: column-reverse;
  }

  /* formation rows become horizontal rows of players */
  .left .formation-row,
  .right .formation-row {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
    padding: 0 6px;
  }

  .player {
    text-align: center;
    cursor: pointer;
  }

  .player-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #fff;
    box-shadow: 0 0 6px rgba(0,0,0,0.35);
  }

  .badge {
    width: 9px;
    height: 12px;
    border-width: 1px;
  }

  .substitute-badge {
    width: 15px;
    height: 15px;
    top: 50%;
    left: -4px;
    transform: translateY(-50%);
  }

  .substitute-badge::before,
  .substitute-badge::after {
    font-size: 7px;
  }

  .goal-badge {
    width: 15px;
    height: 15px;
    font-size: 8px;
    top: -3px;
    right: -3px;
  }

  .owngoal-badge {
    width: 15px;
    height: 15px;
    font-size: 8px;
    bottom: -3px;
    right: -3px;
  }

  .player-name {
    font-size: 10px;
    color: #fff;
    text-shadow: 0 1px 3px rgba(0,0,0,0.6);
    margin-top: 4px;
  }

  .jersey-number {
    top: -6px;
    font-size: 8px;
    min-width: 15px;
    height: 15px;
    border-radius: 8px;
    padding: 0 3px;
    border-width: 1px;
  }
}

</style>
